import styled from 'styled-components'
import { clamp } from '../../styles/utils/conversion.style'
import { breakpoints } from '../../styles/vars/breakpoints.style'
import { colors } from '../../styles/vars/colors.style'
import { Heading1 } from '../../styles/vars/textStyles.style'
import { mq } from '../../styles/vars/media-queries.style'

export const SummaryStatImage = styled.span`
  margin: 0 2.2rem;
  order: ${props => props.order};
  transform: translateY(0.2rem);
  ${clamp('width', 80, 154, breakpoints.desk, breakpoints.contained)};

  ${mq.desk} {
    min-width: 13rem;
  }

  ${props =>
    props.order === 1 &&
    `
    &:first-child {
      margin-left: 0;
    }
  `}

  ${props =>
    props.order === 5 &&
    `
    &:first-child {
      margin-right: 0;
    }
  `}
`

export const SummaryStatImageInner = styled.span`
  height: 100%;
  left: 0;
  opacity: ${props => (props.visible ? 1 : 0)};
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 1;

  &:first-child {
    z-index: 2;
  }

  img {
    height: 100%;
  }
`

export const SummaryStatSpacer = styled.span`
  order: ${props => props.order};
`

export const SummaryStatMain = styled.div`
  ${clamp('padding-bottom', 20, 30, breakpoints.mobile, breakpoints.contained)};
  ${clamp('padding-top', 20, 30, breakpoints.mobile, breakpoints.contained)};
  position: relative;

  &:first-child {
    padding-top: 0;
  }
`

export const SummaryStatText = styled.span`
  display: block;

  ${Heading1} {
    display: flex;
    ${clamp('font-size', 42, 130)}
    pointer-events: none;

    ${mq.deskL} {
      ${clamp('font-size', 42, 140)}
    }
  }

  ${SummaryStatImage} {
    display: none;

    @media (min-width: 1640px) {
      display: inline-block;
    }
  }

  ${SummaryStatSpacer} {
    @media (min-width: 1640px) {
      display: none;
    }
  }
`

export const SummaryStatSpan = styled.span`
  display: inline-flex;
  line-height: 0.8;
  order: ${props => props.order};
  white-space: nowrap;
  user-select: none;
`

export const SummaryStatLine = styled.span`
  background-color: ${colors.light};
  bottom: 0;
  content: '';
  height: 0.1rem;
  left: 0;
  position: absolute;
  ${clamp('right', -22, -49, breakpoints.mobile, breakpoints.contained)}
  transform-origin: 0% 0%;
`
